import { render, staticRenderFns } from "./c-info-mix-background.vue?vue&type=template&id=145c1904&scoped=true"
import script from "./c-info-mix-background.vue?vue&type=script&lang=js"
export * from "./c-info-mix-background.vue?vue&type=script&lang=js"
import style0 from "./c-info-mix-background.vue?vue&type=style&index=0&id=145c1904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c1904",
  null
  
)

export default component.exports